export const getNestedProperty = (obj, key) =>
  key.split('.').reduce((acc, part) => acc && acc[part], obj);
